import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface QrCodeLightboxData {
  imageUrl: string;
  blob?: Blob;
}

@Injectable({
  providedIn: 'root'
})
export class QrcodeLightboxService {
  private _isOpen = new BehaviorSubject<boolean>(false);
  private _qrCodeData = new BehaviorSubject<QrCodeLightboxData | null>(null);

  public isOpen$: Observable<boolean> = this._isOpen.asObservable();
  public qrCodeData$: Observable<QrCodeLightboxData | null> = this._qrCodeData.asObservable();

  constructor() { }

  open(blob: Blob): void {
    const imageUrl = URL.createObjectURL(blob);
    this._qrCodeData.next({ imageUrl, blob });
    this._isOpen.next(true);
  }

  close(): void {
    const currentData = this._qrCodeData.value;
    if (currentData?.imageUrl) {
      URL.revokeObjectURL(currentData.imageUrl);
    }
    this._isOpen.next(false);
    this._qrCodeData.next(null);
  }

  get isOpen(): boolean {
    return this._isOpen.value;
  }

  get qrCodeData(): QrCodeLightboxData | null {
    return this._qrCodeData.value;
  }
}
